import React, {useState} from "react";
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
const CustomDatePicker = props => {
    const [hours , setHours] = useState()
    const [minutes , setMinutes] = useState()
    const [startDate, setStartDate] = useState(
        new Date()
    );
   const selectDate = data => {
       setStartDate(data)
       let time = data
       time = time.getFullYear()+'-'+time.getMonth()+'-'+time.getDay()+'T'+time.getHours()+':'+time.getMinutes()
       props.setTime(time)
   }
    return (
        // eslint-disable-next-line react/jsx-no-undef
        <DatePicker
            selected={startDate}
            onChange={date => selectDate(date)}
            showTimeSelect
            // excludeTimes={[
            //     setHours(setMinutes(new Date(), 0), 17),
            //     setHours(setMinutes(new Date(), 30), 18),
            //     setHours(setMinutes(new Date(), 30), 19),
            //     setHours(setMinutes(new Date(), 30), 17)
            // ]}
            dateFormat="yyyy/MM/d   hh:mm"
        />
    );
};
export default CustomDatePicker
